var olinoUniforms = olinoUniforms || {};
( function () {
    'use strict';
    jQuery( function () {
        olinoUniforms.headerNav.init();
        if(jQuery('.js-olino-create-b2b-user-form-container').length > 0){
            olinoUniforms.createB2Buser.init();
        }
    } );

    olinoUniforms.headerNav = {
        init: function () {
            var jNav = jQuery( '.js-e-nav-global' ),
                jHeader = jQuery( '.e-header' );

            jNav.on('show.bs.dropdown', function () {
                console.log( 'dropdown active' );
                jHeader.addClass('dropdown-is-active' );
            });
            jNav.on('hide.bs.dropdown', function () {
                console.log( 'dropdown hidden' );
                jHeader.removeClass('dropdown-is-active' );
            });
        }
    };
    olinoUniforms.createB2Buser = {
        jForm: null,
        jVatForm: null,
        init: function(){
            olinoUniforms.createB2Buser.jForm = jQuery('.js-olino-create-b2b-user-form-container').find('form[name="UserManagementEditForm"]');
            olinoUniforms.createB2Buser.jVatForm = jQuery('.js-olino-create-b2b-user-form-container').find('form.js-onlino-form-vat-check');
            olinoUniforms.createB2Buser.bindEvents();
            if(jQuery('.js-olino-create-users-error').length > 0) {
                jQuery('#olino-uniforms-create-user-modal').modal('show');
            } else {
                olinoUniforms.createB2Buser.toggleFormGroups('');
            }
        },
        bindEvents: function(){
            olinoUniforms.createB2Buser.jForm.submit(function(event){
            });

            jQuery('.js-olino-create-country-selector').on('change', function(event){
                var jForm = jQuery( event.target ).closest('form'),
                    jSelect = jQuery( event.target ),
                    jSelectedOption = jSelect.find( 'option:selected' );
                jQuery('.js-olino-create-b2b-user-form-container').find('.js-olino-countrycode-target').val(jSelect.val());
                jForm.find( '.js-olino-currencycode-target' ).val( jSelectedOption.data( 'currencycode' ) );
                olinoUniforms.createB2Buser.toggleFormGroups(jSelect.val());
                
            });
            olinoUniforms.createB2Buser.jVatForm.submit(function(event){
                event.stopImmediatePropagation();
                event.stopPropagation();
                event.preventDefault();
                var jForm = jQuery(event.target);
                var postData = jForm.serialize();
                console.log('postData', postData);

                if(jForm.valid()){
                    olinoUniforms.createB2Buser.ajax( jForm, {
                        url: e4.settings.ecom.vatCheck.url,
                        data: postData
                    }, function ( jsonData ) {
                        if(jsonData.Valid){
                            jQuery('#nameField').val(jsonData.Name);
                            jQuery('#vatField').val(jsonData.VatNumber);
                        } else {
                            alert('Vi fandt desværre ingen virksomhed på CVR-nummeret.')
                        }
                    } );
                }
            });
        },
        ajax: function ( jElement, objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                method: 'GET',
                dataType: 'json',
                cache: true,
                beforeSend: function () {
                    jQuery( 'div[for="' + jElement.attr( 'id' ) + '"]' ).addClass( 'is-loading' );
                }
            }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
                setTimeout( function () {
                    jQuery( 'div[for="' + jElement.attr( 'id' ) + '"]' ).removeClass( 'is-loading' );
                }, 250 );
            } );
            /*jqXHR.fail( function ( a, b, c ) {
                console.warn( 'Error response => reload page', a, b, c );
                setTimeout( function () {
                    mch365.admin.ui.prompt.dialog.error( {}, function () {}, [] );
                }, 1000);
            } );
            jqXHR.always(function(a,b,c){
                var object = {};
                objAjaxSettings.data.forEach(function(value, key){
                    object[key] = value;
                });
                if(Object.keys(object).length > 0 && jElement.data('redirectUrl') !== undefined){
                    location.href = jElement.data('redirectUrl');
                }
            });*/
        },
        toggleFormGroups: function(strCountryCode){
            const jFormsContainer = jQuery( '.js-olino-create-b2b-user-form-container' );
            if ( jFormsContainer.find('.js-country-selector-group').length > 0){
                if ( strCountryCode.length > 0 ){
                    jFormsContainer.find('.form-group').removeClass('d-none');
                } else {
                    jFormsContainer.find('.form-group:not(.js-country-selector-group)').addClass('d-none');
                }
                //js-country-selector-group
            }
        }
    };
}());
